import { mutate } from 'swr';
import axios from 'axios';
import { TAssetType } from '../../interfaces';
import { Notistack } from '../../../../../../shared/components/Notistack/Notistack';

export const requestUpdateAssets = (lenderId: string, assets: TAssetType[]) => {
  const path = `/lender-service/lenders/${lenderId}/assetType`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.patch(path, assets);
      Notistack.successMessage('Assets - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
